import { render, staticRenderFns } from "./TagContainer.vue?vue&type=template&id=c346ea72&"
import script from "./TagContainer.vue?vue&type=script&lang=js&"
export * from "./TagContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports